export enum Languages {
    SLOVAK = 'sk',
    ENGLISH = 'en',
    CI_MODE = 'cimode',
}
